// frontend/src/pages/DraftPage.jsx (Versão Corrigida para Produção)

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './DraftPage.css';
import logo from '../assets/logo.png';

// Estrutura de um único contêiner
const initialContainerState = {
  containerNo: '',
  sealArmador: '',
  sealShipper: '',
  containerTareWeight: '',
  packageCount: '',
  packType: '',
  grossWeight: '',
  measurementCBM: '',
  // Novos campos para Reefer
  temperature: '',
  humidity: '',
  ventilation: '',
  // Estados de controle para os botões OFF
  isHumidityOff: false,
  isVentilationOff: false
};

// Estado inicial do formulário
const initialFormState = {
  shipperName: '', shipperInfo: '', consignee: '', notifyParty: '', notifyParty2: '', bookingNo: '', blNo: '', vessel: '', voyage: '', 
  portOfLoading: '', portOfDischarge: '', 
  marksAndNumber: '', cargoDescription: '', ncmCodes: '', 
  netWeight: '', exportReferences: '', ducNumber: '', rucNumber: '', 
  woodDeclaration: 'Treated / Certified',
  signedBlCount: '', blType: '', oblIssuedAt: '', freightType: '',
  containerType: 'Dry', // Padrão é Dry
  containers: [{ ...initialContainerState }]
};

function DraftPage() {
  const [formData, setFormData] = useState(initialFormState);
  const [clientData, setClientData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [noSealShipper, setNoSealShipper] = useState(false);
  const [noBlCount, setNoBlCount] = useState(false);
  const [noMarks, setNoMarks] = useState(false);
  const navigate = useNavigate();

  // --- CORREÇÃO 1: Endereço oficial da API Online ---
  const API_URL = "https://api-draft.hevile.com.br";

  useEffect(() => {
    const fetchClientData = async () => {
      // --- CORREÇÃO 2: Nome correto da chave do token ('token' e não 'accessToken') ---
      const token = localStorage.getItem('token'); 
      
      if (!token) { navigate('/login'); return; }
      try {
        const response = await fetch(`${API_URL}/api/get-client-data`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (!response.ok) throw new Error('Falha na autenticação');
        const data = await response.json();
        setClientData(data);
        setFormData(prev => ({ ...prev, ...data }));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        // Remove o token correto se der erro
        localStorage.removeItem('token');
        navigate('/login');
      }
    };
    fetchClientData();
  }, [navigate]);
  
  const handleNoSealShipperChange = (e) => { const isChecked = e.target.checked; setNoSealShipper(isChecked); };
  const handleNoBlCountChange = (e) => { const isChecked = e.target.checked; setNoBlCount(isChecked); if (isChecked) setFormData(prev => ({ ...prev, signedBlCount: '' })); };
  const handleNoMarksChange = (e) => { const isChecked = e.target.checked; setNoMarks(isChecked); if (isChecked) setFormData(prev => ({ ...prev, marksAndNumber: '' }));};

  // --- Funções de Toggle ---
  const toggleNoSealShipper = () => setNoSealShipper(prev => !prev);
  
  const toggleNoBlCount = () => {
    setNoBlCount(prev => {
      const newState = !prev;
      if (newState) setFormData(prevData => ({ ...prevData, signedBlCount: '' }));
      return newState;
    });
  };

  const toggleNoMarks = () => {
    setNoMarks(prev => {
      const newState = !prev;
      if (newState) setFormData(prevData => ({ ...prevData, marksAndNumber: '' }));
      return newState;
    });
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === 'radio' && formData[name] === value) { setFormData(prevState => ({ ...prevState, [name]: '' })); return; }
    setFormData(prevState => ({ ...prevState, [name]: value }));
    if (e.target.tagName === 'TEXTAREA') { e.target.style.height = 'auto'; e.target.style.height = `${e.target.scrollHeight}px`; }
  };

  const handleContainerChange = (index, e) => {
    const { name, value } = e.target;
    const updatedContainers = [...formData.containers];
    updatedContainers[index][name] = value;
    setFormData(prev => ({ ...prev, containers: updatedContainers }));
  };

  const toggleReeferOption = (index, field) => {
    const updatedContainers = [...formData.containers];
    updatedContainers[index][field] = !updatedContainers[index][field];
    if (updatedContainers[index][field]) {
        if (field === 'isHumidityOff') updatedContainers[index].humidity = '';
        if (field === 'isVentilationOff') updatedContainers[index].ventilation = '';
    }
    setFormData(prev => ({ ...prev, containers: updatedContainers }));
  };

  const addContainer = () => {
    if (formData.containers.length < 20) {
      setFormData(prev => ({ ...prev, containers: [...prev.containers, { ...initialContainerState }] }));
    } else { alert("Você atingiu o limite máximo de 20 contêineres."); }
  };

  const removeContainer = (index) => {
    if (formData.containers.length <= 1) return;
    const updatedContainers = [...formData.containers];
    updatedContainers.splice(index, 1);
    setFormData(prev => ({ ...prev, containers: updatedContainers }));
  };

  const handleSubmit = async () => {
    const mainFields = ['shipperName', 'shipperInfo', 'consignee', 'notifyParty', 'bookingNo', 'vessel', 'voyage', 'portOfLoading', 'portOfDischarge', 'cargoDescription', 'ncmCodes', 'netWeight', 'exportReferences', 'ducNumber', 'rucNumber', 'woodDeclaration'];
    for (const field of mainFields) { if (!formData[field]) { alert(`Por favor, preencha o campo obrigatório: ${field}`); return; } }
    if (!noMarks && !formData.marksAndNumber) { alert("Por favor, preencha Marcas e Números ou marque a opção 'Sem marcas'."); return; }
    if (!noBlCount && !formData.signedBlCount) { alert("Por favor, preencha Número de B/Ls ou marque a opção 'Sem número'."); return; }
    
    for (let i = 0; i < formData.containers.length; i++) {
        const container = formData.containers[i];
        const requiredFields = ['containerNo', 'sealArmador', 'containerTareWeight', 'packageCount', 'packType', 'grossWeight', 'measurementCBM'];
        for (const field of requiredFields) { if (!container[field]) { alert(`Por favor, preencha todos os campos do Contêiner #${i + 1}.`); return; } }
        if (!container.sealShipper && !noSealShipper) { alert(`Por favor, preencha o Lacre Shipper do Contêiner #${i + 1}.`); return; }
        
        if (formData.containerType === 'Reefer') {
             if (!container.temperature) { alert(`Contêiner Reefer #${i+1}: Temperatura é obrigatória.`); return; }
             if (!container.isHumidityOff && !container.humidity) { alert(`Contêiner Reefer #${i+1}: Umidade é obrigatória ou marque 'OFF'.`); return; }
             if (!container.isVentilationOff && !container.ventilation) { alert(`Contêiner Reefer #${i+1}: Ventilação é obrigatória ou marque 'OFF'.`); return; }
        }
    }

    const isConfirmed = window.confirm("Tem certeza que deseja gerar o excel?");
    if (!isConfirmed) return;
    setIsLoading(true);

    let dataToSend = { ...formData };
    if (noBlCount) dataToSend.signedBlCount = '';
    if (noMarks) dataToSend.marksAndNumber = '';
    if (noSealShipper) { dataToSend.containers = dataToSend.containers.map(c => ({...c, sealShipper: ''})); }
    if (formData.containerType === 'Dry') {
        dataToSend.containers = dataToSend.containers.map(c => ({
            ...c, temperature: '', humidity: '', ventilation: ''
        }));
    }

    // --- CORREÇÃO 3: Usar 'token' aqui também ---
    const token = localStorage.getItem('token');

    try {
      const response = await fetch(`${API_URL}/api/generate-file`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(dataToSend),
      });

      if (response.status === 401) throw new Error('Sessão expirada. Faça login novamente.');
      if (!response.ok) throw new Error('Erro ao gerar o arquivo');
      
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const filename = `DRAFT HEVILE - ${formData.shipperName || 'documento'}.xlsx`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      navigate('/success');

    } catch (error) {
      console.error("Erro ao gerar o arquivo:", error);
      alert(error.message || 'Ocorreu um erro.');
      if (error.message.includes('Sessão expirada')) { navigate('/login'); }
    } finally { setIsLoading(false); }
  };

  const Required = () => <span className="required-asterisk">*</span>;

  return (
    <div className="form-container">
      <img src={logo} alt="Logo Hevile" className="logo" />
      <h1>DRAFT HEVILE</h1>
      <form>
        <h2>1. Partes Envolvidas</h2>
        <div className="form-group"><label htmlFor="shipperName">Nome da Empresa (Shipper)<Required /></label><input type="text" id="shipperName" name="shipperName" value={formData.shipperName} onChange={handleChange} required /></div>
        <div className="form-group"><label htmlFor="shipperInfo">Endereço e Informações Adicionais (Shipper)<Required /></label><textarea id="shipperInfo" name="shipperInfo" value={formData.shipperInfo} onChange={handleChange} required></textarea></div>
        <div className="form-group"><label htmlFor="consignee">Consignee / Importador<Required /></label><textarea id="consignee" name="consignee" value={formData.consignee} onChange={handleChange} required></textarea></div>
        <div className="form-group"><label htmlFor="notifyParty">Notify 1<Required /></label><textarea id="notifyParty" name="notifyParty" value={formData.notifyParty} onChange={handleChange} required></textarea></div>
        <div className="form-group"><label htmlFor="notifyParty2">Notify 2 (Opcional)</label><textarea id="notifyParty2" name="notifyParty2" value={formData.notifyParty2} onChange={handleChange}></textarea></div>
        
        <h2>2. Detalhes da Viagem</h2>
        <div className="form-group"><label htmlFor="bookingNo">Booking Nº<Required /></label><input type="text" id="bookingNo" name="bookingNo" value={formData.bookingNo} onChange={handleChange} required /></div>
        <div className="form-group"><label htmlFor="blNo">B/L Nº (Opcional)</label><input type="text" id="blNo" name="blNo" value={formData.blNo} onChange={handleChange} /></div>
        <div className="form-group"><label htmlFor="vessel">Navio (Vessel)<Required /></label><input type="text" id="vessel" name="vessel" value={formData.vessel} onChange={handleChange} required /></div>
        <div className="form-group"><label htmlFor="voyage">Viagem (Voyage)<Required /></label><input type="text" id="voyage" name="voyage" value={formData.voyage} onChange={handleChange} required /></div>
        <div className="form-group"><label htmlFor="portOfLoading">Porto de Embarque<Required /></label><input type="text" id="portOfLoading" name="portOfLoading" value={formData.portOfLoading} onChange={handleChange} required /></div>
        <div className="form-group"><label htmlFor="portOfDischarge">Porto de Desembarque<Required /></label><input type="text" id="portOfDischarge" name="portOfDischarge" value={formData.portOfDischarge} onChange={handleChange} required /></div>
        
        <div className="form-group"><label htmlFor="blType">BL</label>
            <select id="blType" name="blType" value={formData.blType} onChange={handleChange}>
                <option value="">Nenhuma</option>
                <option value="ORIGINAIS">ORIGINAIS</option>
                <option value="TELEX RELEASE / EXPRESS RELEASE">TELEX RELEASE / EXPRESS RELEASE</option>
                <option value="SEA WAYBILL">SEA WAYBILL</option>
            </select>
        </div>

        <div className="form-group"><label htmlFor="oblIssuedAt">OBL ISSUED AT</label><select id="oblIssuedAt" name="oblIssuedAt" value={formData.oblIssuedAt} onChange={handleChange}><option value="">Nenhuma</option><option value="ORIGIN">ORIGIN</option><option value="DESTINATION">DESTINATION</option></select></div>
        <div className="form-group"><label htmlFor="freightType">FREIGHT</label><select id="freightType" name="freightType" value={formData.freightType} onChange={handleChange}><option value="">Nenhuma</option><option value="PREPAID">PREPAID</option><option value="PREPAID ABROAD">PREPAID ABROAD</option><option value="COLLECT">COLLECT</option></select></div>
        
        <div className="form-group" style={{marginTop: '30px', borderTop: '2px dashed #ddd', paddingTop: '20px'}}>
            <label htmlFor="containerType">Tipo de Contêiner<Required /></label>
            <select id="containerType" name="containerType" value={formData.containerType} onChange={handleChange} style={{fontWeight: 'bold', color: '#4f758b'}}>
                <option value="Dry">DRY (Padrão)</option>
                <option value="Reefer">REEFER (Refrigerado)</option>
            </select>
        </div>

        <h2>3. Detalhes do(s) Contêiner(es)</h2>
        
        <div className="toggle-group" style={{padding: '0 10px'}}>
          <button type="button" className={`toggle-btn ${noSealShipper ? 'active' : ''}`} onClick={toggleNoSealShipper}>
            {noSealShipper ? 'Sem lacre shipper (Ativado)' : 'Sem lacre shipper para TODOS'}
          </button>
        </div>

        {formData.containers.map((container, index) => (
          <div key={index} className="container-block">
            <div className="container-header">
              <h4>Contêiner {index + 1} ({formData.containerType})</h4>
              {formData.containers.length > 1 && (<button type="button" className="remove-btn" onClick={() => removeContainer(index)}>Remover</button>)}
            </div>
            
            <div className="form-group"><label htmlFor={`containerNo-${index}`}>Container Nº<Required /></label><input type="text" id={`containerNo-${index}`} name="containerNo" value={container.containerNo} onChange={(e) => handleContainerChange(index, e)} required /></div>
            <div className="form-group"><label htmlFor={`sealArmador-${index}`}>Lacre Armador<Required /></label><input type="text" id={`sealArmador-${index}`} name="sealArmador" value={container.sealArmador} onChange={(e) => handleContainerChange(index, e)} required /></div>
            <div className="form-group"><label htmlFor={`sealShipper-${index}`}>Lacre Shipper</label><input type="text" id={`sealShipper-${index}`} name="sealShipper" value={container.sealShipper} onChange={(e) => handleContainerChange(index, e)} disabled={noSealShipper} required={!noSealShipper} /></div>
            <div className="form-group"><label htmlFor={`containerTareWeight-${index}`}>Peso de Tara (Kgs)<Required /></label><input type="text" id={`containerTareWeight-${index}`} name="containerTareWeight" value={container.containerTareWeight} onChange={(e) => handleContainerChange(index, e)} required /></div>
            <div className="form-group"><label htmlFor={`packageCount-${index}`}>Qtd. Volumes<Required /></label><input type="text" id={`packageCount-${index}`} name="packageCount" value={container.packageCount} onChange={(e) => handleContainerChange(index, e)} required /></div>
            <div className="form-group"><label htmlFor={`packType-${index}`}>Tipo Embalagem<Required /></label><input type="text" id={`packType-${index}`} name="packType" value={container.packType} onChange={(e) => handleContainerChange(index, e)} required /></div>
            <div className="form-group"><label htmlFor={`grossWeight-${index}`}>Peso Bruto (Kgs)<Required /></label><input type="text" id={`grossWeight-${index}`} name="grossWeight" value={container.grossWeight} onChange={(e) => handleContainerChange(index, e)} required /></div>
            <div className="form-group"><label htmlFor={`measurementCBM-${index}`}>Cubagem (CBM)<Required /></label><input type="text" id={`measurementCBM-${index}`} name="measurementCBM" value={container.measurementCBM} onChange={(e) => handleContainerChange(index, e)} required /></div>

            {formData.containerType === 'Reefer' && (
                <div style={{backgroundColor: '#eef5f9', padding: '10px', borderRadius: '8px', marginTop: '15px'}}>
                    <h5 style={{margin: '0 0 10px 0', color: '#4f758b'}}>Dados de Refrigeração</h5>
                    <div className="form-group"><label htmlFor={`temperature-${index}`}>Temperatura<Required /></label><input type="text" id={`temperature-${index}`} name="temperature" value={container.temperature} onChange={(e) => handleContainerChange(index, e)} placeholder="Ex: -18 C" required /></div>
                    <div className="form-group reefer-toggle-group">
                        <div style={{flex: 1}}>
                            <label htmlFor={`humidity-${index}`}>Umidade (%)<Required /></label>
                            <input type="text" id={`humidity-${index}`} name="humidity" value={container.humidity} onChange={(e) => handleContainerChange(index, e)} placeholder="Ex: 60%" disabled={container.isHumidityOff} required={!container.isHumidityOff} />
                        </div>
                        <button type="button" className={`toggle-btn ${container.isHumidityOff ? 'active' : ''}`} onClick={() => toggleReeferOption(index, 'isHumidityOff')}>
                            {container.isHumidityOff ? 'OFF' : 'OFF'}
                        </button>
                    </div>
                    <div className="form-group reefer-toggle-group">
                        <div style={{flex: 1}}>
                            <label htmlFor={`ventilation-${index}`}>Ventilação (CBM/H)<Required /></label>
                            <input type="text" id={`ventilation-${index}`} name="ventilation" value={container.ventilation} onChange={(e) => handleContainerChange(index, e)} placeholder="Ex: 15 CBM/H" disabled={container.isVentilationOff} required={!container.isVentilationOff} />
                        </div>
                        <button type="button" className={`toggle-btn ${container.isVentilationOff ? 'active' : ''}`} onClick={() => toggleReeferOption(index, 'isVentilationOff')}>
                            {container.isVentilationOff ? 'OFF' : 'OFF'}
                        </button>
                    </div>
                </div>
            )}
          </div>
        ))}
        <button type="button" className="add-btn" onClick={addContainer}>Adicionar Contêiner</button>
        
        <h2>4. Detalhes da Carga (Gerais)</h2>
        <div className="form-group">
          <label htmlFor="marksAndNumber">Marcas e Números</label>
          <input type="text" id="marksAndNumber" name="marksAndNumber" value={formData.marksAndNumber} onChange={handleChange} disabled={noMarks} />
          <div className="toggle-group" style={{marginTop: '10px'}}>
            <button type="button" className={`toggle-btn ${noMarks ? 'active' : ''}`} onClick={toggleNoMarks}>
              {noMarks ? 'Sem marcas (Ativado)' : 'Sem marcas'}
            </button>
          </div>
        </div>

        <div className="form-group"><label htmlFor="cargoDescription">Descrição da Carga<Required /></label><textarea id="cargoDescription" name="cargoDescription" value={formData.cargoDescription} onChange={handleChange} required></textarea></div>
        <div className="form-group"><label htmlFor="ncmCodes">Códigos NCM (separados por vírgula)<Required /></label><textarea id="ncmCodes" name="ncmCodes" value={formData.ncmCodes} onChange={handleChange} required></textarea></div>
        <div className="form-group"><label htmlFor="netWeight">Peso Líquido Total (Kgs)<Required /></label><input type="text" id="netWeight" name="netWeight" value={formData.netWeight} onChange={handleChange} required /></div>
        
        <h2>5. Documentação</h2>
        <div className="form-group"><label htmlFor="exportReferences">Referências de Exportação / Fatura<Required /></label><input type="text" id="exportReferences" name="exportReferences" value={formData.exportReferences} onChange={handleChange} required /></div>
        <div className="form-group"><label htmlFor="ducNumber">DU-E Nº<Required /></label><input type="text" id="ducNumber" name="ducNumber" value={formData.ducNumber} onChange={handleChange} required /></div>
        <div className="form-group"><label htmlFor="rucNumber">RUC Nº<Required /></label><input type="text" id="rucNumber" name="rucNumber" value={formData.rucNumber} onChange={handleChange} required /></div>
        <div className="form-group"><label htmlFor="woodDeclaration">Declaração de Madeira<Required /></label><select id="woodDeclaration" name="woodDeclaration" value={formData.woodDeclaration} onChange={handleChange}><option value="Treated / Certified">Treated / Certified</option><option value="Not Applicable">Not Applicable</option><option value="Processed">Processed</option><option value="Not Treated / Not Certified">Not Treated / Not Certified</option></select></div>
        
        <div className="form-group">
          <label htmlFor="signedBlCount">Número de B/Ls Originais</label>
          <input type="text" id="signedBlCount" name="signedBlCount" value={formData.signedBlCount} onChange={handleChange} disabled={noBlCount} />
          <div className="toggle-group" style={{marginTop: '10px'}}>
            <button type="button" className={`toggle-btn ${noBlCount ? 'active' : ''}`} onClick={toggleNoBlCount}>
              {noBlCount ? 'Sem número (Ativado)' : 'Sem número'}
            </button>
          </div>
        </div>
        
        <button type="button" className="main-btn" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? 'Gerando Arquivo...' : 'Gerar Excel'}
        </button>
      </form>
    </div>
  );
}

export default DraftPage;